import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdditionalAEDataFormRequest } from "../../../../http/requests/applications/additionalAEData.http";

export const fetchGetAdditionalAEData = createAsyncThunk("additionalAeData/get", async () => {
  const response = await getAdditionalAEDataFormRequest();
  return response.data;
});
